class MaterialDrawer extends HTMLElement {
  constructor() {
    super();

    // Get drawer container and trigger element
    this.section = document.querySelector('.drawer-material');
    this.triggerDrawer = document.querySelector('.distribution-notice-box__content-box');
    this.materialsTriggerDrawer = document.querySelector('.product-info-materials-note span');
    this.drawerMaterials = document.querySelectorAll('.material-drawer');

    // Exit early if either element is missing
    if (!this.section) return;

    this.openMaterialDrawer = this.openMaterialDrawer.bind(this);
    this.closeMaterialDrawer = this.closeMaterialDrawer.bind(this);
    this.addDrawerListeners();
    this.checkIfMaterialDrawer();
    this.closeMaterialDrawer();
  }

  addDrawerListeners() {
    if (this.triggerDrawer) {
      this.triggerDrawer.classList.add('tw-cursor-pointer');
      this.triggerDrawer.removeEventListener('click', this.openMaterialDrawer);
      this.triggerDrawer.addEventListener('click', this.openMaterialDrawer);
    }
    if (this.materialsTriggerDrawer) {
      this.materialsTriggerDrawer.classList.add('tw-cursor-pointer');
      this.materialsTriggerDrawer.removeEventListener('click', this.openMaterialDrawer);
      this.materialsTriggerDrawer.addEventListener('click', this.openMaterialDrawer);
    }
  }

  removeDrawerListeners() {
    if (this.triggerDrawer) {
      this.triggerDrawer.classList.remove('tw-cursor-pointer');
      const link = this.triggerDrawer.querySelector('a');
      if (link) link.style.display = 'none';
      this.triggerDrawer.removeEventListener('click', this.openMaterialDrawer);
    }
    if (this.materialsTriggerDrawer) {
      this.materialsTriggerDrawer.removeEventListener('click', this.openMaterialDrawer);
      this.materialsTriggerDrawer.style.display = 'none';
      const svg = document.querySelector('.product-info-materials-note svg');
      if (svg) svg.style.display = 'none';
    }
  }

  checkIfMaterialDrawer() {
    const colorVariantPicker = document.querySelectorAll('.product-form__input.product-form__input--swatch input[name="Color"]');
    const checked = Array.from(colorVariantPicker).find((m) => m.checked);
    if (checked) {
      const hasMatch = Array.from(this.drawerMaterials).some((drawerMaterial) => drawerMaterial.dataset.name === checked.value);
      hasMatch ? this.addDrawerListeners() : this.removeDrawerListeners();
    }
    colorVariantPicker.forEach((material) => {
      material.addEventListener('click', () => {
        const hasMatch = Array.from(this.drawerMaterials).some((drawerMaterial) => drawerMaterial.dataset.name === material.value);
        if (!hasMatch) {
          this.removeDrawerListeners();
        } else {
          this.addDrawerListeners();
          if (this.materialsTriggerDrawer) this.materialsTriggerDrawer.style.display = 'inline-flex';
          const link = this.triggerDrawer?.querySelector('a');
          if (link) link.style.display = 'inline-flex';
          const svg = document.querySelector('.product-info-materials-note svg');
          if (svg) svg.style.display = 'block';
        }
      });
    });
  }

  openMaterialDrawer() {
    // Find all elements representing material options inside the drawer
    const materials = document.querySelectorAll('.material-drawer');

    // Loop through each material element
    materials.forEach((material) => {
      // Get the input element associated with the label's tooltip (using the material's dataset.name)
      const input = this.getInputByLabelTooltip(material.dataset.name);
      if (!input) return;

      // Show only the currently selected material
      if (input.checked) {
        material.classList.add('show');
      } else {
        material.classList.remove('show');
      }
    });

    // Slight delay to allow transition, then show the drawer and prevent page scroll
    setTimeout(() => {
      document.body.classList.add('overflow-hidden');
      this.section.classList.add('active');
    }, 10);
  }

  // Function to close the material drawer
  closeMaterialDrawer() {
    this.section.addEventListener('click', (e) => {
      const isClickOnCloseIcon = e.target.classList.contains('icon-close');
      const isClickOnOverlay = e.target.classList.contains('drawer-material');
      const clickedOutsideDrawer = !e.target.closest('.drawer__inner');
      if (isClickOnCloseIcon || isClickOnOverlay || clickedOutsideDrawer) {
        this.section.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  // Helper: Find input by matching label's data-tooltip attribute
  getInputByLabelTooltip(tooltipValue) {
    // Find the label element with the given tooltip value
    const label = document.querySelector(`label[data-tooltip="${tooltipValue}"]`);
    if (!label) return null;

    // Get the associated input's ID from the label's "for" attribute
    const inputId = label.getAttribute('for');
    if (!inputId) return null;

    // Return the input element
    return document.getElementById(inputId);
  }
}

if (!customElements.get('material-drawer')) {
  customElements.define('material-drawer', MaterialDrawer);
}
